import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@mantine/core/styles.css";
import "antd/dist/reset.css";
import { AppWrapper } from "./AppWrapper";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_REACT_APP_ENV ?? "production",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 0.2,
  tracePropagationTargets: [import.meta.env.VITE_REACT_APP_SERVER],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  ignoreErrors: [
    // Auth0 noise
    "Login required",
    "Invalid state",
    // Network noise
    "NetworkError",
    "Failed to fetch",
    "Load failed",
    "Network request failed",
    "The network connection was lost",
    // ResizeObserver benign loop
    "ResizeObserver loop limit exceeded",
    "ResizeObserver loop completed with undelivered notifications",
    // Chunk loading on deploys
    /ChunkLoadError/,
    /Loading chunk \d+ failed/,
  ],
});

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(<AppWrapper />);
